/**
 * mcycle homepage product item creator
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import './productItem.css';
import React from 'react';
import { Link } from 'react-router-dom';

const ProductItem = ({id, link, name, price}) => {
  return <Link to={{ pathname: `/view/appraisal/${id}` }}>
    <li className="mcycle-product-item">
      <span className="mcycle-product-item-img">
        <img src={ link } alt="product-item" />
      </span>
      <p className="mcycle-product-item-name">{ name }</p>
      <p className="mcycle-product-item-price">近期回收最高价 ￥{ price }</p>
    </li>
  </Link>
}

export default ProductItem



// WEBPACK FOOTER //
// ./src/components/home/productList/productItem/productItem.js